import React from 'react';

const SensorConfiguration = ({ getSettingValue }) => {
  const outlet2EnabledSetting = getSettingValue('outlet_2_enabled');
  const outlet2Enabled = outlet2EnabledSetting.value === 1 || outlet2EnabledSetting.value === '1' || outlet2EnabledSetting.value === true;

  return (
    <div className="space-y-6">
      {/* Outlet 2 Sensor Status */}
      <div className="bg-white rounded-lg border border-gray-300 shadow-sm p-6">
        <div className="flex justify-between items-center mb-4">
          <span className="text-lg font-semibold text-gray-800">Outlet 2 Sensor</span>
          <span className={`px-3 py-1 rounded-full text-sm font-bold ${
            outlet2Enabled
              ? 'bg-green-100 text-green-700'
              : 'bg-gray-100 text-gray-500'
          }`}>
            {outlet2Enabled ? 'Enabled' : 'Disabled'}
          </span>
        </div>
        <p className="text-gray-500 text-sm">
          When enabled, outlet 2 moisture readings are averaged with the primary outlet sensor for more accurate discharge moisture measurement.
        </p>
      </div>
    </div>
  );
};

export default SensorConfiguration;
